import styled from 'styled-components';
import { Card, Select, Transfer } from 'antd';
import { IThemeProps } from 'store/ducks/globalTypes';

export const ContentWrapper = styled('div')`
  width: 100%;
  padding: 24px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const TransferCard = styled(Card)<IThemeProps>`
  background: #fff;
  border: 1px solid #52c41a;
  padding: 12px;

  .ant-card-head-title {
    color: ${(props) =>
      props.scheme === 'greenModeTheme' ? 'inherit' : '#000 !important'};
  }

  .ant-transfer {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .ant-transfer-list {
    width: 100% !important;
    max-width: 400px;
  }

  .ant-select {
    width: 100%;
    margin-bottom: 12px;
  }

  @media (max-width: 768px) {
    .ant-transfer-list {
      max-width: 100%;
    }
  }
`;

export const SelectParent = styled(Select)`
  width: 100%;
  margin-bottom: 16px;
`;

export const ProcessTransferCards = styled(Transfer)`
  width: 100%;
`;
